import Cookies from "js-cookie";
import BlueArrowIcon from "../assets/images/blue-arrow.png";
import GreenArrowIcon from "../assets/images/green-arrow.png";
import OrangeArrowIcon from "../assets/images/orange-arrow.png";

export const getFAQSettings = (isUsersQue, isProvidersQue) => {
  let bgColor;
  let color;
  let arrow;
  let questions;
  let heading;

  switch (true) {
    case isUsersQue:
      heading = "For Users";
      bgColor = "#FFF7EF";
      color = "#FF820F";
      arrow = OrangeArrowIcon;
      break;
    case isProvidersQue:
      heading = "For Service Provider";
      bgColor = "#F4FFF8";
      color = "#06A445";
      arrow = GreenArrowIcon;
      break;
    default:
      heading = "Common Questions";
      bgColor = "#EFF3FF";
      color = "#0072DD";
      arrow = BlueArrowIcon;
      break;
  }

  return { bgColor, color, arrow, questions, heading };
};

/* The function `getCookieConsent` checks if the cookie consent has been accepted by retrieving the value of the "cookieConsent" cookie.*/
export const getCookieConsent = () => {
  return Cookies.get("cookieConsent") === "accepted";
};

/* The function `setCookieConsent` sets a cookie named "cookieConsent" with the value "accepted" that expires in 365 days.*/
export const setCookieConsent = () => {
  Cookies.set("cookieConsent", "accepted", { expires: 365 });
};

/* The `truncateString` function shortens a given string to a specified length and appends "..." if the string exceeds the specified length.
 * @param str - A string that want to truncate.
 * @param num - The `num` parameter in the `truncateString` function represents the maximum length of the string `str` after truncation.*/
export const truncateString = (str, num) => {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + "...";
};

/* The function `getInitialChar` takes a name as input, splits it into words, extracts the first character of each word, converts them to uppercase, and returns the initials, with a maximum length of 2 characters.
 * @param name - The `getInitialChar` function takes a `name` parameter as input. This parameter should be a string representing a person's name.*/
export const getInitialChar = (name) => {
  const names = name.split(" ");
  const initials = names.map((n) => n.charAt(0).toUpperCase()).join("");
  return initials.length > 2 ? initials.slice(0, 2) : initials;
};
